import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'
import {
  staffMemberService,
  staffRoleService,
  payClassificationService,
} from '$services'

// Defines what data should be loaded for this component, the data in here is
// fetched in parallel with navigating to the route and is then passed to the
// component as a prop.
export default async function loader({ params }) {
  const packageDetail = mercuryApi.get(
    `/pay-rules/packages/${params.packageId}`
  )

  const staffMembers = staffMemberService
    .getAll(undefined, true, false)
    .then((staffMembers) =>
      staffMembers.map(({ id, name, datestampDeleted }) => ({
        id: id!,
        label: name,
        display: datestampDeleted == null,
      }))
    )

  const staffRoles = staffRoleService.getAll().then((staffRoles) =>
    staffRoles.map(({ id, name, datestampDeleted }) => ({
      id: id!,
      label: name!,
      display: datestampDeleted == null,
    }))
  )

  const payClassifications = payClassificationService
    .getAll()
    .then((payClassifications) =>
      payClassifications.map(({ id, name }) => ({
        id: id!,
        label: name!,
      }))
    )

  return defer({
    data: Promise.all([
      packageDetail,
      staffMembers,
      staffRoles,
      payClassifications,
    ]),
  })
}
